// Firebase configuration file
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration for the correct project
// Using the same config as the student app since it's the same Firebase project
const firebaseConfig = {
  apiKey: "AIzaSyA2XNcUUXbGT9LDWVtSHUlZtl0F0dYEhYM",
  authDomain: "cte-rsvp.firebaseapp.com",
  projectId: "cte-rsvp",
  storageBucket: "cte-rsvp.firebasestorage.app",
  messagingSenderId: "741299085271",
  appId: "1:741299085271:web:a348019a274debfb60b592"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { app, db, storage, auth };